import { render, staticRenderFns } from "./payDayBill.vue?vue&type=template&id=3180ac33&scoped=true"
import script from "./payDayBill.vue?vue&type=script&lang=js"
export * from "./payDayBill.vue?vue&type=script&lang=js"
import style0 from "./payDayBill.vue?vue&type=style&index=0&id=3180ac33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3180ac33",
  null
  
)

export default component.exports